import SuperSimpleAccordions from "./modules/accordion";
import AccordionTabs from "./modules/accordion-tabs";
import flipcards from "./modules/flipcards";
import blinds from "./modules/blinds";
import navigation from "./modules/navigation";
import Swiper, { Autoplay, Lazy, EffectFade, A11y, Navigation, Pagination } from "swiper";
import updateExternalLinks from "./modules/updateExternalLinks";
import "element-closest-polyfill";
import { ModalPopup } from "./modules/modal";
import SimpleLightbox from "simplelightbox/dist/simple-lightbox.modules";
import { ModalCards } from "./modules/modalcards";
import { ModalLink } from "./modules/modallink";
import VerticalTabs from "./modules/vertical-tabs";
import StickyElement from "./modules/stickyElem";
//import initGallery from "./modules/Gallery";

import { EmbeddedMap } from "./modules/embeddedMap";

Swiper.use([Autoplay, Navigation, Lazy, EffectFade, A11y, Pagination]);

const init = () => {
	//Init accordions
	if (document.querySelector(".accordion")) {
		const accordions = new SuperSimpleAccordions(".accordion", {
			iconsClass: "plus-icon",
			iconsSymbol: "plus-minus", // arrow or plus-minus
			iconsPosition: "left", // right or left
			expandAllBtn: false,
			expandAllContainerClass: "accordion__toggle-all-container right"
		});
	}

	if (document.querySelector(".accordion-tabs")) {
		const accordionTabs = new AccordionTabs(".accordion-tabs", {
			icons: false, // arrow or plus-minus
			expandAllBtn: false
		});
	}

	if (document.querySelector(".flip-cards__toggle")) {
		flipcards.init();
	}

	if (document.querySelector(".blinds")) {
		blinds.init();
	}

	if (document.querySelector(".slideshow")) {
		var slideSwiper = new Swiper(".slideshow", {
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev"
			},
			spaceBetween: 48,
			loop: true,
			preloadImages: false,
			lazy: true,
			a11y: {
				containerMessage: "Image slideshow",
				enabled: true,
				firstSlideMessage: "This is the first slide",
				lastSlideMessage: "This is the last slide"
			}
		});
	}
};
document.addEventListener("DOMContentLoaded", function () {
	navigation.init();

	if (document.querySelector(".rotating-images")) {
		var imagesSwiper = new Swiper(".rotating-images", {
			autoplay: {
				delay: 8000
			},
			effect: "fade",
			fadeEffect: {
				crossFade: true
			},
			loop: true,
			preloadImages: false,
			lazy: true,
			a11y: {
				containerMessage: "Image slideshow",
				enabled: true,
				firstSlideMessage: "This is the first slide",
				lastSlideMessage: "This is the last slide"
			}
		});
	}

	updateExternalLinks('.main-content [target="_blank"], .news-artices p [target="_blank"], .external-link');

	if (document.querySelector(".main-content__title")) {
		let contentTitle = document.querySelector(".main-content__title");
		let contentTitleArr = contentTitle.textContent.split(" ");

		if (contentTitleArr.length > 3) {
			let stickyWord = "\xa0" + contentTitleArr.pop();
			contentTitle.innerText = contentTitleArr.join(" ") + stickyWord;
		}
	}

	if (document.querySelector(".lightbox")) {
		let lightbox = new SimpleLightbox(".lightbox", {
			captionsData: "data-caption",
			fileExt: false,
			scaleImageToRatio: true
		});
	}

	let scrollElems = document.querySelectorAll(".scrollTo");
	for (var i = 0; i < scrollElems.length; i++) {
		scrollElems[i].addEventListener("click", function (e) {
			var target = this.hash;
			document.querySelector(target).scrollIntoView({
				behavior: "smooth"
			});
		});
	}

	ModalPopup();

	init();

	const mapSelector = "mapEmbed";
	if (document.querySelector(`#${mapSelector}`)) {
		const mapEmbed = document.getElementById(mapSelector);

		EmbeddedMap(mapSelector, () => {
			new SuperSimpleAccordions(`.${mapSelector}Dialog .accordion`, {
				iconsClass: "plus-icon",
				iconsSymbol: "plus-minus", // arrow or plus-minus
				iconsPosition: "left", // right or left
				expandAllBtn: false,
				expandAllContainerClass: "accordion__toggle-all-container right"
			});

			new Swiper(`.${mapSelector}Dialog .slideshow`, {
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev"
				},
				spaceBetween: 48,
				loop: true,
				preloadImages: false,
				lazy: true,
				a11y: {
					containerMessage: "Image slideshow",
					enabled: true,
					firstSlideMessage: "This is the first slide",
					lastSlideMessage: "This is the last slide"
				}
			});
		});
	}
	VerticalTabs();
	ModalCards();
	ModalLink();
	var stickyNav = document.getElementById('stickyNav');
	var stickyStop
	StickyElement("stickyNav", "sec106-map-heading");
});
